export const breakpoints = {
  values: {
    xs: 0,
    sm: 700,
    md: 900,
    lg: 1200,
    xl: 1536,
  },
}
